import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from '../locales/en-CA.json';
import fr from '../locales/fr-CA.json';

// English / French (docs/architecture.md §17a). Every visible string goes through here; the
// locale files must have identical keys (i18n.test.ts).

export const LANGS = ['en-CA', 'fr-CA'] as const;
export type Lang = (typeof LANGS)[number];
const STORAGE_KEY = 'clairo.lang';

function initialLang(): Lang {
  try {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved === 'en-CA' || saved === 'fr-CA') return saved;
  } catch {
    // Storage blocked: fall through to the browser language.
  }
  return navigator.language.toLowerCase().startsWith('fr') ? 'fr-CA' : 'en-CA';
}

void i18n.use(initReactI18next).init({
  resources: { 'en-CA': { translation: en }, 'fr-CA': { translation: fr } },
  lng: initialLang(),
  fallbackLng: 'en-CA',
  interpolation: { escapeValue: false },
  returnObjects: true,
});

i18n.on('languageChanged', (lng) => {
  document.documentElement.lang = lng;
  try {
    localStorage.setItem(STORAGE_KEY, lng);
  } catch {
    // Not remembered; still switched for this session.
  }
});
document.documentElement.lang = i18n.language;

export function setLanguage(lang: Lang): void {
  void i18n.changeLanguage(lang);
}

export default i18n;
